export default __webpack_public_path__ + "static/media/404.b9aaa249.jpg";